import { createLightTheme, webLightTheme, BrandVariants } from '@fluentui/react-components';


const brand: BrandVariants = {
    10: '#020305', 20: '#071426', 30: '#0A1F3A', 40: '#0D294E', 50: '#103362',
    60: '#143E77', 70: '#18488A', 80: '#1A529E', 90: '#1D5DB3', 100: '#2067C7',
    110: '#2B74CF', 120: '#3B82D6', 130: '#4A90DD', 140: '#5A9EE4', 150: '#6AACEB',
    160: '#79BAF2'
};


export const appTheme = createLightTheme(brand);
export const baseTheme = webLightTheme;